import { json } from "react-router-dom";
import { authHeader, isTokenExpired } from "../helpers";

export const myGeolocalisedServices = {
  getGeolocalisedComponents,
  createOrUpdateGeolocalisedComponent,
  deleteGeolocalisedComponent,
};

function getGeolocalisedComponents() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(true),
  };

  const url = `${process.env.REACT_APP_GATEWAY_URL}/admin/geolocated-components`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function createOrUpdateGeolocalisedComponent(
  data,
  isUpdate = false,
  id = null
) {
  const requestOptions = {
    method: isUpdate ? "PUT" : "POST",
    headers: authHeader(),
    body: JSON.stringify(data),
  };

  const url = `${
    process.env.REACT_APP_GATEWAY_URL
  }/admin/geolocated-components${isUpdate ? `/${id}` : ""}`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function deleteGeolocalisedComponent(id) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };

  const url = `${process.env.REACT_APP_GATEWAY_URL}/admin/geolocated-components/${id}`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

// delete post (ajout) put (update)
